import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "../lib/api";

export function ProductGallery({ product }) {
  const images = [product.cover_key, ...(product.gallery_keys || [])].filter(Boolean);
  const [i, setI] = useState(0);
  const go = (n) => setI((i + n + images.length) % images.length);

  if (images.length === 0) {
    return <div className="card-flat aspect-[4/5] bg-[#f4f5f7] flex items-center justify-center text-[#4a4a4a] font-serif text-6xl">{product.name?.[0]}</div>;
  }
  return (
    <div data-testid="product-gallery">
      <div className="card-flat overflow-hidden aspect-[4/5] bg-[#f4f5f7] relative group">
        <img key={images[i]} data-testid="gallery-main-image" src={fileUrl(images[i])} alt={`${product.name} ${i + 1}`} className="w-full h-full object-cover animate-[fadeIn_.4s_ease]" />
        {images.length > 1 && (
          <>
            <button data-testid="gallery-prev" onClick={() => go(-1)} aria-label="Previous image" className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#0a192f]/80 text-white flex items-center justify-center hover:bg-[#d4af37] hover:text-[#0a192f] transition-colors"><ChevronLeft className="w-5 h-5" /></button>
            <button data-testid="gallery-next" onClick={() => go(1)} aria-label="Next image" className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#0a192f]/80 text-white flex items-center justify-center hover:bg-[#d4af37] hover:text-[#0a192f] transition-colors"><ChevronRight className="w-5 h-5" /></button>
            <div data-testid="gallery-counter" className="absolute bottom-3 right-3 bg-[#0a192f]/80 text-white text-xs px-2 py-1 tracking-widest">{i + 1} / {images.length}</div>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 mt-3 overflow-x-auto" data-testid="gallery-thumbs">
          {images.map((k, idx) => (
            <button key={k} data-testid={`gallery-thumb-${idx}`} onClick={() => setI(idx)} className={`w-16 h-20 flex-shrink-0 overflow-hidden border-2 transition-colors ${idx === i ? "border-[#d4af37]" : "border-transparent hover:border-[#0a192f]"}`}>
              <img src={fileUrl(k)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
      <style>{`@keyframes fadeIn { from { opacity: .4 } to { opacity: 1 } }`}</style>
    </div>
  );
}
